import { get, flowRight } from 'lodash';
import { connect } from 'react-redux';
import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import { hideModal } from '../../components/BookingContainer/BookingContainerActions';
import {
    BOOKING_CONTAINER_ROOT_KEY,
    SCHEDULING_ROOT_KEY,
} from '../../constants';
import { ModalContentView } from './ModalContentView';

export const mapStateToProps = (state = {}) => {
    return {
        ariaLabel: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.ariaLabel'
        ),
        modalName: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.modalName'
        ),
        headerText: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.headerText'
        ),
        descriptionText: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.descriptionText'
        ),
        primaryButtonText: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.primaryButtonText'
        ),
        secondaryButtonText: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.secondaryButtonText'
        ),
        onClickPrimaryButton: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.onClickPrimaryButton'
        ),
        onClickSecondaryButton: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.onClickSecondaryButton'
        ),
        bookingId: get(state[SCHEDULING_ROOT_KEY], 'bookingState.id'),
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        onClickClose: () => dispatch(hideModal()),
    };
};

export const ModalContentConnector = flowRight(
    connect(mapStateToProps, mapDispatchToProps),
    withCustomMetrics({
        page: 'Booking',
        category: 'Booking - Appt Info',
    })
)(ModalContentView);
